<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <alert/>
        <applyform v-if="$store.state.applyformShow"/>

        <aside style="display: none;" :style="{'right': asideRight}">
            <div class="pack-up" @click="asidePackUp">收起 >></div>
            <ul>
                <li @click="openQidiankefu">
                    <img src="./assets/aside/server.png" alt="">
                </li>
                <li>
                    <a href="//eshop.dellemc-solution.com/">
                        <img src="./assets/aside/shop.png" alt="">
                    </a>
                </li>
                <li>
                    <a href="tel:4008846610" @click="gioPhone">
                        <img src="./assets/aside/tel.png" alt="">
                    </a>
                </li>
                <li>
                    <a href="//www.dellemc-solution.com/campaigns/try/mobile-c/">
                        <img src="./assets/aside/back.png" alt="">
                    </a>
                </li>
            </ul>
        </aside>
        <div class="aside-open" :style="{right: unfold}" @click="asidePackUp">
            {{asideOpenText}}
        </div>

        <topNav />
    </div>
</template>

<script>
    import {EventBus} from "./event-bus.js";
    import applyform from '@/components/applyform.vue';
    import topNav from "@/components/topNav";
    import alert from '@/components/alert.vue';

    export default {
        name: 'App',
        data() {
            return {
                asideRight: 0,
                asideOpenText: '<<',
                unfold: '-100%',
                shortUrl: ''
            }
        },
        props: ['test'],
        components: {
            //HelloWorld
            applyform,
            alert,
            topNav,
        },

        mounted: function () {


            if (this._isMobile()) {
                // console.log('手机端');
                //this.$router.replace('/homeAndroid');
            } else {
                // console.log('pc端');
                // this.$router.replace('/Home');
            }

            //this.$store.commit('setApplyformShow',true)
        },

        methods: {
            // 判断移动端还是pc端
            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },
            asidePackUp: function () {
                if (this.asideRight == 0) {
                    this.asideRight = '-60px';
                    this.unfold = 0;
                } else {
                    this.asideRight = 0;
                    this.unfold = '-100%'
                }

            },
            initEventBus() {

            },
            initStore() {

                //this.getUserInfo();
                this.$store.commit('setState', {
                    authed: this.cookies.get('sys_newuserinfo') ? true : false
                })

                //this.$store.state.authed = true;
                if (this.$store.state.authed === true) {
                    console.log('已授权')
                    this.getUserInfo();
                } else {
                    console.log('未授权')
                }

            },
            getUserInfo() {
                this.axios
                    .get('/campaigns-b/try/index.php?_c=callback&_a=userinfo')
                    .then((response) => {
                        console.log('userinfo~~~~~')
                        var d = response.data.data;
                        // console.log(response.data.data)

                        this.$store.commit('setState', {
                            userInfo: d,
                            userInfoId: d.id,
                            site_yhxy: d.site_yhxy || ''
                        })
                    }).catch(function (error) { // 请求失败处理
                    console.log(error);
                });
            },

            async openQidiankefu() {

                if (!this.shortUrl) {
                    this.shortUrl = await this.getShortUrl();
                }
                var seoName = this.getCookie('seoName') || '';

                // 跳转链接
                var kefuUrl = 'https://wpa1.qq.com/19iXqr7M?_type=wpa&qidian=true'
                    + '&wpaShowItemId=123&qidian_ex1=' + this.shortUrl
                    + '&qidian_ex2='
                    + '&qidian_ex3='
                    + '&qidian_ex4=' + '0元试用活动'
                    + '&qidian_ex5=' + seoName;

                console.log('shortUrl', this.shortUrl);
                console.log('客服链接', kefuUrl);
                console.log('搜索引擎', seoName);

                gio('track', 'click_presalesConsult');  //埋点实施方案

                window.open(kefuUrl);
            },

            gioPhone() {
                gio('track', 'eshop400clickMO_campaign');
            },

        },
        created() {
            console.log('app ' + this.test);
            /*
            this.cookies.set('name','test')
            console.log('this.cookies');
            console.log(this.cookies.get('name'));
            */

            this.initEventBus();
            //   this.initStore();
            this.getShortUrl();
            this.adTokenBd();
        }
    }
</script>

<style lang="scss">
    html, body {
        width: 100%;
        height: 100%;
        position: relative;
    }

    li {
        list-style-type: none;
    }

    * {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
    }

    a {
        text-decoration: none;
    }

    .portrait {
        border-radius: 50%;
    }

    #app {
        background: #315182;
        /* padding-bottom: 0.263157rem * 0.75; */
        width: 100%;
        min-height: 100%;
        padding-bottom: 1.39rem;
        font-size: .24rem;
        font-family:  '微软雅黑','Microsoft YaHei',"Helvetica Neue",Helvetica,Tahoma,Arial,'PingFang SC','Source Han Sans CN','Source Han Sans','Source Han Serif','Hiragino Sans GB','WenQuanYi Micro Hei',sans-serif;;
    }

    .u-flex {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    /* 换行 */
    .u-flex-wrap {
        flex-wrap: wrap;
    }

    /* 不换行 */
    .u-flex-nowrap {
        flex-wrap: nowrap;
    }

    /* 垂直居中 */
    .u-col-center {
        align-items: center;
    }

    /* 顶部对齐 */
    .u-col-top {
        align-items: flex-start;
    }

    /* 底部对齐 */
    .u-col-bottom {
        align-items: flex-end;
    }

    /* 左边对齐 */
    .u-row-left {
        justify-content: flex-start;
    }

    /* 水平居中 */
    .u-row-center {
        justify-content: center;
    }

    /* 右边对齐 */
    .u-row-right {
        justify-content: flex-end;
    }

    /* 水平两端对齐，项目之间的间隔都相等 */
    .u-row-between {
        justify-content: space-between;
    }

    /* 水平每个项目两侧的间隔相等，所以项目之间的间隔比项目与父元素两边的间隔大一倍 */
    .u-row-around {
        justify-content: space-around;
    }


    // 定义flex等分
    @for $i from 0 through 12 {
        .u-flex-#{$i} {
            flex: $i;
        }
    }

    .base-btn {
        outline: none;
        border: none;
        display: block;
        margin: .15rem auto .15rem;
        width: 2.2rem;
        height: .56rem;
        line-height: .56rem;
        text-align: center;
        font-size: .3rem;
        color: #fff;
        background-image: linear-gradient(-90deg, rgb(130, 11, 6) 1%, rgb(223, 28, 20) 100%);

        &:active {
            opacity: .9;
        }

        &.disabled {
            background-image: linear-gradient(-90deg, rgb(133, 133, 133) 1%, rgb(106, 106, 106) 100%);
        }
    }


    .aside-open {
        position: fixed;
        right: -100%;
        top: 50%;
        /*width: 60px;*/
        padding: 4px 10px;
        border-radius: 4px 0 0 4px;
        color: #ffffff;
        text-align: center;
        z-index: 99999;
        transition: all .3s;

    }

    aside {
        position: fixed;
        right: 0;
        top: 50%;
        width: 60px;
        height: auto;
        z-index: 99999;
        transition: all .3s;
    }

    aside .pack-up {
        margin-bottom: 10px;
        background-color: #2f4e7c;
        padding: 4px 0;
        border-radius: 4px 0 0 4px;
        color: #ffffff;
        text-align: center;
        font-size: .24rem;
    }

    aside ul li {
        margin: 5px 0;
    }

    aside ul li img {
        width: 40px;
        height: 40px;
    }


    .demo {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        z-index: 1;
        opacity: 0.5;
    }

    .demo.hide {
        display: none;
    }

    h3 {
        color: #7e2b2b;
        font-size: 0.4rem * 0.75;
        font-family: "MicrosoftYaHei";
        text-align: center;
    }

    h4 {
        color: #7e2b2b;
        font-size: 0.303571rem * 0.75;
        font-family: "MicrosoftYaHei";
        text-align: center;
    }

    .font1 {
        color: #fff;
        font-size: 0.078947rem * 0.75;
        font-family: "MicrosoftYaHei";
        text-align: center;
        display: block;
    }


    .page {

        width: 100%;
        margin-left: auto;
        margin-right: auto;
    }

    .top-state {
        background-image: url('./assets/top-state.png');
        background-size: 100% auto;
        background-repeat: no-repeat;
        width: 5.464285rem * 0.75;
        height: 0.821428rem * 0.75;
        margin-left: auto;
        margin-right: auto;
        color: #3599a2;
        text-align: center;
        line-height: 0.821428rem * 0.75;
    }

    .page .container {
        position: relative;
        z-index: 3;
        margin: 0 auto;
        width: 91.3vw;
        background: #d2e8ff;
        border-radius: 0.9vw;
    }

    .containerHeader {
        background-size: 100% auto;
        background-repeat: no-repeat;
        width: 9.625rem * 0.75;
        height: 0.696428rem * 0.75;
    }

    .containerMiddle {
        background-size: 100% auto;
        min-height: 0.105263rem * 0.75;
        padding-left: 0.157894rem * 0.75;
        padding-right: 0.157894rem * 0.75;
        padding-bottom: 0.078947rem * 0.75;
        padding-top: 1px;
    }

    .containerFooter {
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 9.625rem * 0.75;
        height: 0.535714rem * 0.75;
    }

    .containerHeader2 {
        background-image: url('./assets/contentBgHeader2.png');
        background-size: 100% auto;
        background-repeat: no-repeat;
        height: 0.063157rem * 0.75;
    }

    .containerMiddle2 {
        /* background-color: #fff; */
        min-height: 0.105263rem * 0.75;
        padding-bottom: 0.078947rem * 0.75;
    }

    .containerFooter2 {
        background-image: url('./assets/contentBgFooter2.png');
        background-size: 100% auto;
        background-repeat: no-repeat;
        height: 0.052631rem * 0.75;
    }


    .containerMiddle .content {
        background-color: #fff;
        border-radius: 10px;
        display: flex;
        min-height: 1.052631rem * 0.75;
        flex-direction: column;
        margin-bottom: 1.2vw;
        padding: 3.5vw;
        justify-content: space-around;
        position: relative;
    }


    .containerMiddle .content.center {
        justify-content: center;
    }


    .content .row {
        display: flex;
        justify-content: center;
    }

    .content .top {
        align-self: flex-start;
    }


    .content .bottom {
        align-self: flex-end;
    }


    .userInfo {
        margin-top: 2vw;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 2rem * 0.75;
    }

    .userInfo .tx {
        background-image: url('./assets/txBg2.png');
        background-size: 100% auto;
        background-repeat: no-repeat;
        width: .59rem;
        height: .59rem;
        overflow: hidden;
    }

    .tx img {
        width: 100%;
    }

    .userInfo .name {
        font-size: .26rem;
        color: #000;
        padding-left: .25rem;
        font-weight: bold;
    }

    .fontSize4 {
        font-size: 0.31rem * 0.75;
    }

    .fontSize3 {
        font-size: 0.357142rem * 0.75;
    }

    .fontSize2 {
        font-size: 0.4rem * 0.75;
    }

    .fontSize1 {
        font-size: 0.625rem * 0.75;
    }

    .bold {
        font-weight: bold;
    }

    .btn3 {
        color: #fff;
        background-image: url('./assets/查看详情.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 1.821428rem * 0.75;
        height: 0.508928rem * 0.75;
        text-align: center;
        line-height: 0.508928rem * 0.75;
        padding: 0.05rem * 0.75;
        padding-right: 0.2rem * 0.75;
        overflow: hidden;
    }

    .btn3:after {
        position: absolute;
        left: 0;
        top: -0.1rem * 0.75;
        width: .2rem * 0.75;
        height: 0.8rem * 0.75;
        background-color: rgba(255, 255, 255, 0.4);
        transform: rotate(30deg);
        content: '';
        animation: light-move 0.5s ease-out infinite;
    }

    .btn3:before {
        position: absolute;
        left: 0;
        top: -0.1rem * 0.75;
        width: .2rem * 0.75;
        height: 0.8rem * 0.75;
        background-color: rgba(225, 225, 225, 0.4);
        transform: rotate(30deg);
        content: '';
        animation: light-move-delay 0.5s ease-out infinite;
    }

    .textLeft {
        text-align: left !important;
    }

    .logo {
        width: 3rem * 0.75;
        float: left;
        padding-top: 0.5rem * 0.75;
        padding-left: 0.9rem * 0.75;
    }

    .logo img {
        width: 100%;
    }


    .detail_info {
        color: #1277da;
        font-size: 2.8vw;
    }

    .detail_info img {
        max-width: 100%;
        display: block;
    }

    @keyframes light-move {
        0% {
            left: -0.4rem
        }
        100% {
            left: 2.4rem * 0.75;
        }
    }

    @keyframes light-move-delay {
        0% {
            left: -.8rem
        }
        100% {
            left: 2rem * 0.75;
        }
    }

    .elli1 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    //多行文字溢出
    .elli2 {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .elli3 {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }

    /*特殊处理*/
    #index-banner-img-1049{
        width: 4.2rem;
        height: 4.2rem;
        top: -.6rem;
    }
    #detail-banner-img-1049{
        width: 4.8rem;
        height: 4.8rem;
        margin-top: -.5rem;
    }

    #detail-banner-img-1050{
        width: 4.8rem;
        height: 4.8rem;
        margin-top: -.4rem;
    }
</style>

